import { render } from "./Gene_GeneExpression.vue?vue&type=template&id=5c6957a4"
import script from "./Gene_GeneExpression.vue?vue&type=script&lang=js"
export * from "./Gene_GeneExpression.vue?vue&type=script&lang=js"

import "./Gene_GeneExpression.vue?vue&type=style&index=0&id=5c6957a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__